import { contactData } from '@/mocks/home';

export default function ContactSection() {
  return (
    <section id="contact" className="py-10 md:py-14 bg-background-50">
      <div className="max-w-[700px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 text-center mb-3">{contactData.title}</h2>
        <p className="text-sm md:text-base text-foreground-600 text-center mb-8 md:mb-10 leading-relaxed">{contactData.desc}</p>
        <div className="bg-background-100 rounded-xl border border-background-200/70 p-6 md:p-8">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6 mb-6">
            <div className="text-center">
              <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-primary-50 flex items-center justify-center">
                <i className="ri-mail-line text-primary-600 text-xl"></i>
              </div>
              <p className="text-xs text-foreground-500 mb-1">电子邮箱</p>
              <p className="text-sm font-label font-medium text-foreground-800">{contactData.email}</p>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-accent-50 flex items-center justify-center">
                <i className="ri-wechat-line text-accent-600 text-xl"></i>
              </div>
              <p className="text-xs text-foreground-500 mb-1">微信公众号</p>
              <p className="text-sm font-label font-medium text-foreground-800">{contactData.wechat}</p>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-secondary-100 flex items-center justify-center">
                <i className="ri-qq-line text-secondary-500 text-xl"></i>
              </div>
              <p className="text-xs text-foreground-500 mb-1">QQ客服</p>
              <p className="text-sm font-label font-medium text-foreground-800">{contactData.qq}</p>
            </div>
          </div>
          <div className="border-t border-background-200/70 pt-5 space-y-2">
            {contactData.tips.map((tip, idx) => (
              <p key={idx} className="text-xs text-foreground-500 flex items-start gap-2">
                <span className="text-primary-500 flex-shrink-0 mt-0.5">·</span>
                {tip}
              </p>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}